import { Subject } from 'rxjs';
import UsuarioModel from '../models/usuario.model';

const subject = new Subject();
const subjectLogout = new Subject();

export const UsuarioEfetuouLoginService = {
    sendMSG: (msg: UsuarioModel) => subject.next(msg),
    getMSG: () => subject.asObservable()
};

export const UsuarioEfetuouLogOutService = {
    sendMSG: (msg: boolean) => subjectLogout.next(msg),
    getMSG: () => subjectLogout.asObservable()
};